/* Gogo Language Texts
Table of Contents
01.General
02.User Login, Logout, Register
03.Menu
04.Error Page
*/
import countryList from "./en_country_list";

export default () => {
  return {
    /* 00. Languages */
    en: "English",
    tr: "Turkish",
    de: "German",

    /* 01.General */
    countryList,
    "Network Error!": "Network Error!",
    Reconnecting: "Reconnecting",
    "Retry Now": "Retry Now",
    "Please allow notifications": "Please allow notifications",
    "Please check your internet connection": "Please check your internet connection",
    "You are currently offline": "You are currently offline",
    "Old Version": "Old Version",
    "Your version is old. Please refresh your browser to reload!": "Your version is old. Please click here to refresh your browser",
    connected_to_the_server: "Connected to the server",
    this_user_does_not_have_permission_for_this_hotel: "This user does not have permission for this hotel",
    permission_error: "Permission Error",
    dateOptions: {
      yearFormat: "numeric",
      monthFormat: "long",
      dayFormat: "2-digit",
      locale: "en-US"
    },
    click_to_load: "Click to load more.",
    click_to_load_until: "Showing until ",
    click_to_load_number: " Showing (",
    seen_all: "You have seen it all.",
    birthdate_format: "DD/MM/YY",
    // 'form.valid.peopleCount': 'people count is required and must be greater then 0',
    // 'form.valid.childCount': '',

    "form.valid.firstname": "Firstname is required",
    "form.valid.lastname": "Lastname is required",
    "form.valid.price": "Amount is not valid",
    "form.valid.email": "Email is not valid",
    "form.valid.mobile": "Phone number is not valid - ex:+123xxxxxxxxxx",
    "form.valid.roomnumber": "Room number is not valid",
    "form.valid.decimal": "Decimal value is not valid",
    "link.webeeCode": "Webee Code:",
    "link.copyCode": "Copy Webee Code",
    "link.header": "Create URL for Payment",
    "link.modalheader": "Link",
    "link.copy": "Copy Link",
    "link.error": "Something went wrong, please try again!",
    "createQr.create_link": "Create QR For Download Link",
    "createQr.create_booking_with_pms": "Create QR for PMS",
    "createQr.success": "Create Qr Success",
    "createQr.error": "Something went wrong, please try again!",
    "link.goReport": "Report Pages",
    "link.copied": "Copied to Clipboard",
    "report.expired": "Expired",
    "report.not_expired": "Available",
    "report.header": "Report",
    "report.pay": "Paid",
    "report.not_pay": "Not Paid",
    "report.no_payments": "No Payments",
    "report.permisson_error_payments": "You have not a access in here",
    "forms.firstname": "Firstname",
    "forms.lastname": "Lastname",
    "forms.price": "Amount:",
    "forms.email": "E-mail",
    "forms.start_date": "Start Date",
    "forms.end_date": "End Date",
    "forms.mobile": "Phone no:",
    "forms.phone_number": "+123xxxxxxxxxx",
    "forms.check_in_check_out": "Check-In / Check-Out:",
    "forms.generate": "Generate URL",
    "forms.please_select": "Please Select",
    "forms.create": "Create",
    "forms.checkin": "Checkin Date",
    "forms.checkout": "Checkout Date",
    "forms.room_number": "Room Number",
    "forms.send_sms": "Send SMS",
    "forms.send_email": "Send e-mail",
    "forms.select_contact": "You can select contact information",
    "forms.select_pms": "Guest List",

    /* Alacarte */
    "alacarte.food_undefined": "Main course selection is not available for this restaurant",
    "alacarte.grand_total": "Grand Total",
    "alacarte.total_order": "Total Order",
    "alacarte.restaurant_name": "Restaurant Name",
    "alacarte.request_time": "Request Time",
    "alacarte.restaurants_header": "Restaurants",
    "alacarte.no_restaurants": "No Restaurants",
    "alacarte.mondays": "Monday",
    "alacarte.tuesdays": "Tueasday",
    "alacarte.wednesdays": "Wednesday",
    "alacarte.thursdays": "Thursday",
    "alacarte.fridays": "Friday",
    "alacarte.saturdays": "Saturdays",
    "alacarte.sundays": "Sundays",
    "alacarte.quota": "Person",
    "alacarte.days": "Days",
    "alacarte.success": "Success",
    "alacarte.addSlot": "Add Slot",
    "alacarte.reservation_slot": "Reservation Slot",
    "alacarte.removeSlot": "Remove Slot",
    "alacarte.stop_res_before_opens_at": "Stop Booking Before Opening (minutes)",
    "alacarte.guest_cancel_res_before_open_at": "Guests Can Cancel Booking Before Opening (minutes)",
    "alacarte.max_guest_count": "Maximum number of people can make a reservation",
    // 'alacarte.main_course': 'Main Course Required',
    "alacarte.guest_one_res_each_day": "Guests can make one reservation per day",
    "alacarte.guest_one_res_per_resturant": "Guests can make one reservation per restaurant",
    "alacarte.yes": "Yes",
    "alacarte.no": "No",
    "alacarte.alacarte": "Alacarte",
    "alacarte.no_config": "No Config",
    "alacarte.newRequest": "New Request",
    "alacarte.print": "Print",
    "alacarte.request_owner_staff": "Request owner is staff",
    "alacarte.allday": "All Day",
    "alacarte.available_seats": "Available Seats",
    "alacarte.info_available_seats": "No chosen time slots yet",
    "alacarte.main_course": "Main Courses",
    "alacarte.person": "Person",
    "alacarte.adult": "Adult",
    "alacarte.adult_count": "Adult Count",
    "alacarte.child": "Child",
    "alacarte.room_number": "Room Number",
    "alacarte.name": "Name Surname",
    "alacarte.notes": "Notes",
    "alacarte.select_restaurant_and_slot": "Select Restaurant And Slot",
    "alacarte.people_count": "People Count",
    "alacarte.child_count": "Children Count",
    "alacarte.create_form": "Create Form",
    "alacarte.create_request": "Create Request",
    "alacarte.request_person_info": "Person Info",
    "alacarte.request_no_person_info": "No Person Info",
    "alacarte.input_required": "(*) required input fields must be filled.",
    "alacarte.count": "count",
    "alacarte.date": "Date",
    "alacarte.time": "Time Slot",
    "alacarte.total_request": "Total Request",
    "alacarte.total_person": "Total Person",
    "alacarte.total_child": "Total Child",

    /* Fast Checkin */
    "fastCheckin.guests": "Guests",

    /* 02.User Login, Logout, Register, Create, Update */
    "user.signout": "Sign Out",
    "user.login-title": "Login",
    "user.gsmNo": "GSM No:",
    "user.sendCode": "Send Code",
    "user.resendCode": "Re-Send Code",
    "user.confirmationCode": "Confirmation Code",
    "user.cancel": "Cancel",
    "user.close": "Close",
    "user.modalChangePassword": "Change Password",
    "user.resetPassword": "Reset Password",
    "user.changePassword": "Change Password",
    "user.passwordChangeSuccess": "Your password has been changed",
    "user.passwordChangeError": "Something went wrong!, please try again!",
    "user.oldPassword": "Old Password",
    "user.newPassword": "New Password",
    "user.confirmPassword": "Confirm Password",
    "user.register": "Register",
    "user.forgot-password": "Forgot Password",
    "user.email": "E-mail",
    "user.note": "Note",
    "user.all_number": "All Number",
    "user.password": "Password",
    "user.forgot-password-question": "Forget password?",
    "user.fullname": "Full Name",
    "user.login-button": "LOGIN",
    "user.register-button": "REGISTER",
    "user.reset-password-button": "RESET",
    "user.buy": "BUY",
    "user.username": "Username",
    "user.create": "Create Config",
    "user.update": "Update Config",

    /* 03.Menu */
    "menu.requests": "Requests",
    "menu.fastCheckin": "Contactless Check-in",
    "menu.logs": "Guest Logs",
    "menu.lolRequests": "Land Of Legends Requests",
    "menu.bookings": "Bookings",
    "menu.payments": "Payments",
    "menu.settings": "Settings",
    "menu.template": "Message Templates",
    "menu.reportProblem": "Report a Problem",
    "menu.problemDescription": "Problem Description",
    "menu.chooseTopic": "Choose a topic title",
    "menu.descriptionFieldCannotLeftEmpty": "The description field cannot left empty",
    "menu.problemSubject": "Problem Subject",
    "menu.sendReport": "Send Report",
    "menu.sendReportConfirmMessage": "Are you sure send a report ?",
    "menu.link": "Create Link",
    "menu.report": "Payment Report",
    "menu.app": "Home",
    "menu.staff": "Staff",
    "menu.dashboards": "Dashboards",
    "menu.gogo": "Gogo",
    "menu.start": "Start",
    "menu.second-menu": "Second Menu",
    "menu.second": "Second",
    "menu.ui": "UI",
    "menu.charts": "Charts",
    "menu.chat": "Chat",
    "menu.survey": "Survey",
    "menu.request": "Requests",
    "menu.search": "Search",
    "menu.docs": "Docs",
    "menu.blank-page": "Blank Page",
    "menu.empty_badge": "No new notifications",
    "menu.alacarte": "Alacarte Reservations",
    "menu.restaurant": "Restaurants",
    "menu.ringTone": "Change Ring Tone",

    /* 04.Pages */
    "pages.error-title": "Ooops... looks like an error occurred!",
    "pages.error-code": "Error code",
    "pages.go-back-home": "GO BACK HOME",
    "pages.display-options": "Display Options",
    "pages.orderby": "Order By : ",

    /* 05.Request */
    "request.payable": "Payable Request",
    "request.payable_status": "Payment Status",
    "request.payable_total_amount": "Total Amount",
    "request.payable_currency": "Currency",
    "request.payable_payment": "Payment",
    "request.no_payable_details": "no details yet",

    "request.payable_status_paid": "Paid",
    "request.payable_status_canceled": "Canceled",
    "request.payable_status_awaiting_payment": "Awaiting Payment",

    "request.order_number": "Place of the Order",
    "request.add-new": "NEW REQUEST",
    "request.add-new-title": "Create New Request",
    "request.comment": "Comment",
    "request.due": "Due Date",
    "request.title": "Title",
    "request.detail": "Detail",
    "request.category": "Service Type",
    "request.label": "Label",
    "request.status": "Status",
    "request.cancel": "Cancel",
    "request.submit": "Submit",
    "request.error": "Please Select at least a Service Type",
    "request.action": "Action",
    "request.another-action": "Another action",
    "request.display-options": "Display Options",
    "request.orderby": "Order By : ",
    "request.all-tasks": "All",
    "request.pending-tasks": "Pending",
    "request.open-tasks": "Open",
    "request.completed-tasks": "Closed",
    "request.canceled-tasks": "Canceled",
    "request.list_status_canceled": "Canceled",
    "request.categories": "Types",
    "request.labels": "Labels",
    "request.clear": "Clear",
    "request.guest": "Guest",
    "request.details": "Details",
    "request.room": "Room",
    "request.collapse_all": "Collapse All",
    "request.expand_all": "Expand All",
    "request.request_details": "Request Details",
    "request.no_booking_info": "No booking information",
    // 'request.chat_say_something': 'Here you can start a conversation with the guest...',
    "request.chat_say_something": "Send message to the guest...",
    "request.message_title": "Messages",
    "request.last_update": "Last update: ",
    "request.created_at": "Created at: ",
    "request.Creation Date": "Creation Date",
    "request.Last Update": "Last Update",
    "request.Due Date": "Due Date",
    "request.Guest Name": "Guest Name",
    "request.Service Name": "Service Name",
    "request.due_date": "Due date: ",
    "request.empty_message_box": "No messages",
    "request.message_send_button": "Send",
    "request.upload": "Upload",
    "request.wrong_request_page": "No Such Request Exists",
    "request.awaiting_approval_status_message": "Firstly, you must update the Booking status of the guest to take any action regarding the request",
    "request.empty_request_list": "No Requests",
    "request.details_action_re_open": "Re Open",
    "request.Status": "Status",
    "request.status_open": "Open",
    "request.status_pending": "Pending",
    "request.status_closed": "Closed",
    "request.status_canceled": "Canceled",
    "request.details_action_submit_as_resolved": "Submit as resolved",
    "request.clear_filters": "Clear filters",
    "request.back_button": "Back",
    "request.message_view_translation": "View Translation",
    "request.message_show_original": "Show Original",
    "request.message_translation_detect": "DETECTED",
    "request.message_translation": "TRANSLATED",
    "request.pageUp": "Up",
    "request.create_qr": "Create QR",
    "request.webeepass_message": "Scan code to download app and once download is completed, scan code to activate membership.",
    "request.create_qr_pms": "WeBee PASS",
    "request.modalCreateQR": "WeBee PASS",
    "request.survey_score": "Survey Score",

    /* 06.Booking */
    "booking.guest_information_form": "Guest Information Form",
    "booking.signature": "Signature",
    "booking.date": "Date",
    "booking.full_name": "Name / Surname",
    "booking.has_traveled": "I have traveled in the last 14 days.",
    "booking.billing_address": "Billing Address",
    "booking.passport_front": "Passport Front",
    "booking.passport_back": "Passport Back",
    "booking.address": "Address",
    "booking.has_pet": "Do you have a pet?",
    "booking.city": "City",
    "booking.country": "Country",
    "booking.town_of_registry": "Town of registry",
    "booking.city_of_registry": "City of registry",
    "booking.serial_number": "Serial Number",
    "booking.document_type": "Document Type",
    "booking.date_of_issue": "Date of issue",
    "booking.date_of_expire": "Date of expiry",
    "booking.birth_place": "Birth Place",
    "booking.mother_name": `Mother's Name`,
    "booking.father_name": `Father's Name`,
    "booking.dietary_requirements": "Dietary Requirements if any",
    "booking.postal_code": "Postal Code",
    "booking.arrival_flight": "Arrival Flight",
    "booking.departure_flight": "Departure Flight",
    "booking.visa_type": "Visa Type",
    "booking.visa_expiry_date": "Visa Expiry Date",
    "booking.room_assignment": "Room Assigment",
    "booking.OK": "OK",
    "booking.car_plate": "Car Plate",
    "booking.reservation_channel": "Reservation Channel",
    "booking.time_of_arrival_at_hotel": "Time Of Arrival at Hotel",
    "booking.all-reservations": "All",
    "booking.status_hotel_guest": "Hotel guest",
    "booking.status_future_guest": "Future guest",
    "booking.status_awaiting_approval": "Awaiting approval",
    "booking.status_invalid_booking": "Invalid reservation",
    "booking.status_checked_out": "Checked Out",
    "booking.molainn_keyless_access_status_verified": "VERIFIED",
    "booking.molainn_keyless_access_status_pending": "PENDING",
    "booking.molainn_keyless_access_status_rejected": "REJECTED",
    "booking.molainn_keyless_access_status_expired": "EXPIRED",
    "booking.molainnKeylessAccessWarningMessage": "To grant door opening permission, you need to change the accommodation status to 'Hotel Guest'.",
    "booking.add-new": "ADD NEW",
    "booking.firstname-label": "First Name",
    "booking.lastname-label": "Last Name",
    "booking.internal-notes-label": "Internal Notes",
    "booking.phone-label": "Phone",
    "booking.firstname-placeholder": "First Name",
    "booking.lastname-placeholder": "Last Name",
    "booking.internal-notes-placeholder": "Internal Notes",
    "booking.phone-placeholder": "Phone number",
    "booking.add-new-modal-title": "Create New Booking",
    "booking.empty_booking_list": "No Bookings",
    "booking.label": "Label",
    "booking.status": "Status",
    "booking.submit": "Submit",
    "booking.cancel": "Cancel",
    "booking.room": "Room",
    "booking.checkin": "Arrival",
    "booking.booking_summary": "Booking Details",
    "booking.checkout": "Departure",
    "booking.display-options": "Display Options",
    "booking.orderby": "Order By : ",
    "booking.hescode": "Hes Code",
    "booking.TM6Form_number": "TM6 Form Number",
    "booking.empty_request_list": "No Bookings",
    "booking.wrong_booking_page": "No Such Booking Exists",
    "bookingDetails.hotel_guest": "Hotel Guest",
    "bookingDetails.future_guest": "Future Guest",
    "bookingDetails.awaiting_approval": "Awaiting Approval",
    "bookingDetails.invalid_booking": "Invalid Reservation",
    "bookingDetails.checked_out": "Checked Out",
    "bookingDetails.reservation_number": "Reservation Number",
    "bookingDetails.national_identification_number": "National Identification Number",
    "bookingDetails.passport_number": "Passport Number",
    "bookingDetails.birth_date": "Birthdate",
    "bookingDetails.checkin_checkout": "Checkin / Checkout",
    "bookingDetails.checkin_checkout_time": "Checkin Time / Checkout Time",
    "bookingDetails.keyless_active_switch": "Is Active",
    "bookingDetails.keyless_invoke": "Revoke Key",
    "booking.loyalty_program": "Loyalty Program",
    "bookingDetails.room": "Room",
    "bookingDetails.room_info": "No room info",
    "bookingDetails.gender": "Gender",
    "bookingDetails.genderFemale": "Female",
    "bookingDetails.genderMale": "Male",
    "bookingDetails.tp_id": "Third Party Resource ID (PMS - Resource ID)",
    "bookingDetails.nationality": "Nationality",
    "bookingDetails.startPlaceHolder": "Start",
    "bookingDetails.endPlaceHolder": "End",
    "bookingDetails.select_one": "Select one",
    "bookingDetails.checkin": "Check-in",
    "bookingDetails.checkout": "Check-out",
    "bookingDetails.back_button": "Back",
    "bookingDetails.last_update": "Last update: ",
    "bookingDetails.created_at": "Created at: ",
    "bookingDetails.Loyalty_and_preferences": "Loyalty And Guest Preferences",
    "bookingDetails.loyalty_point": "Loyalty Point",
    "bookingDetails.guest_preferences": "Guest Preferences",
    "bookingDetails.check_with_pms": "Repeat Check Pms",
    "bookingDetails.check_with_pms_button": "Check Pms",

    // 08 Easee
    "menu.easee": "EaSee",
    "menu.webeeadmin": "Webee Admin",

    // 09 Template Message
    "template.newTemplate": "New Template",
    "template.language": "Language",
    "template.title": "Title",
    "template.text": "Text",
    "template.choose": "Choose your template message",
    "template.chooseLang": "Select Language",
    "template.add": "Add New Template",
    "template.edit": "Edit Template",
    "template.save": "Save",
    "template.cancel": "Cancel",
    "template.noTemplate": "There is no Template message , You can create a template message.",
    "template.delete": "Are you sure you want to delete this template?",
    "template.delete-title": "Delete Template",
    "template.delete-button": "Delete",

    // 10 Ringtone
    "ringTone.sound": "Sound",
    "ringTone.playChoose": "Play / Choose",

    /* 11 MODAL */
    "modal.close": "Close",

    // 12 Announcement
    "announcement.popupSubject": "New Feature: Easy way to report a problem!",
    "announcement.popupBody":
      'If you have any problem or suggestion with the StaffApp, you can go to the "Report a Problem" tab under the settings and report your problems easily to the support team.'
  };
};
